/**
 * uiString.js
 * Talkroute
 *
 * Created by Vel Genov on 12/27/18
 * Copyright (c) 2018 Talkroute. All right reserved.
 */


 const preferences = {
  CALL_HISTORY: {
    TITLE: "Call History",
    PLAY_BUTTON_TOOLTIP_LABEL: "Play Recording",
    NO_RECORDING_AVAILABLE_TOOLTIP_LABEL: "No Recording Available",
    NO_RECORDS: "No records found",
    TABLE_COL_LABELS: ["Date",	"Time",	"Phone Number",	"Duration",	"Recording Details"],
    FILTERS: {
      START_DATE: "Start Date",
      END_DATE: "End Date",
      VOICE_MAILBOX: "Voice Mailbox",
      VIRTUAL_NUMBERS: "Virtual numbers",
      USER: "User / Forwarding Number",
      EXTENSION: "Extension",
      ALL: "All",
      ANSWERED: "Answered",
      MISSED: "Missed",
      HANGUP: "Hangup",
      LONGER: "Longer",
      SHORTER: "Shorter",
      SECONDS: "Seconds",
      MINUTES: "Minutes",
      HOURS: "Hours",
      DAYS: "Days",
      INBOUND: "Inbound",
      OUTBOUND: "Outbound",
      RESULT: "Result",
      DURATION_OPERATOR: "Duration",
      DURATION: "Duration",
      DIRECTION: "Direction",
      FORWARDING_NUMBER: "User / Forwarding Number",
      MENU_OPTIONS: "Menu Option",
      VIRTUAL_NUMBER_ALL: "Virtual Number - All",
      STATUS_ALL: "Status - All",
      ADVANCED_FILTERS: "Advanced Filters",
      APPLY_FILTERS: "Apply filters",
      RESET: "Reset",
    },
    CALL_DETAILS: {
      BLOCK: "Block Phone Number",
      UNBLOCK: "Unblock Phone Number",
      VIRTUAL_NUMBER: "Virtual Number",
      CALLED_NUMBER: "Called Number",
      NOT_AVAILABLE: "Not available",
      DIRECTION: "Direction",
      RESULT: "Result",
      CALL_RESULT_NOT_AVAILABLE_TOOLTIP: "Results and events for calls prior to the update on February 7, 2018 are not available. For more details, please see this <a href=\"https://support.talkroute.com/hc/en-us/articles/360000214267\" target=\"_blank\">FAQ</a>.",
      CALL_DETAILS: "Call Details",
      CALL_DETAILS_NOT_AVAILABLE_TOOLTIP: "Results and events for calls prior to the update on February 7, 2018 are not available. For more details, please see this <a href=\"https://support.talkroute.com/hc/en-us/articles/360000214267\" target=\"_blank\">FAQ</a>.",
    },
    TOOLTIPS: {
      NO_CALL_DETAILS: "No call details available",
      NO_CALL_DETAILS_FAQ: "Results and events for calls prior to the update on February 7, 2018 are not available. For more details, please see this ",
      BLOCK_NUMBER: "Block Phone Number",
      EXPORT_TO_CSV: "Export to CSV File",
    }
  },
  TEXT_MESSAGING_HISTORY: {
    TITLE: "Text Message History",
    NO_RECORDS: "No records found",
    TABLE_COL_LABELS: ["Date",	"Time",	"Virtual Number", "Contact / Phone Number",	"Messages",	"Transcript", "Details"],
    FILTERS: {
      START_DATE_FIRST_MESSAGE: "First Message - After",
      END_DATE_FIRST_MESSAGE: "First Message - Before",
      START_DATE_LAST_MESSAGE: "Last Message - After",
      END_DATE_LAST_MESSAGE: "Last Message - Before",
      GREATER_THAN: "Greater than",
      LESS_THAN: "Less than",
      EQUAL: "Equal to",
      VIRTUAL_NUMBER_ALL: "Virtual Number - All",
      USER_ALL: "User - All",
      ADVANCED_FILTERS: "Advanced Filters",
      APPLY_FILTERS: "Apply filters",
      RESET: "Reset",
    },
    DETAILS: {
      TO: "To",
      VIRTUAL_PHONE_NUMBER: "Virtual Phone Number",
      TOTAL_MESSAGE_COUNT: "Total Message Count",
      CONVERSATION: "Conversation",
      LAST_MESSAGE_DETAILS: "Last Message Details",
      MESSAGE: "Message",
      SENT_AT: "Sent At",
      SENT_BY: "Sent By",
    }
  },
  FORWARDING_NUMBERS: {
    TITLE: "Forwarding Phone Numbers",
    TABLE_COL_LABELS: ["Phone Number", "Description",	"Call Announce Enabled"],
    DESCRIPTION_REQUIRED_ERROR: "The description field is required",
    NUMBER_REQUIRED_ERROR: "The number field is required",
    DESCRIPTION_TOO_LONG_ERROR: "The description may not be longer than 40 characters",
    INVALID_NUMBER_ERROR: "The phone number is invalid",
    ADD_PHONE_NUMBER: "Add Phone Number",
    CALL_ANNOUNCE_AND_TALKROUTE_VOICEMAIL: "Voicemail & Call Announce Enabled",
    CREATE_DIALOG: {
      TITLE: "Add a Forwarding Phone Number",
      PHONE_DESCRIPTION: "Description",
      NUMBER: "Phone Number",
      ENABLE_CALL_ANNOUNCE_AND_VOICEMAIL: "Enable Call Announce & Talkroute Voicemail",
    },
    EDIT_DIALOG: {
      TITLE: "Edit Phone Number",
    },
    DELETE_DIALOG: {
      TITLE: "Delete Forwarding Phone Number",
      BODY_TEXT: "Are you sure you want to permanently remove this number?"
    }
  },
  TRANSFER_CODES: {
    TITLE: "Transfer Codes",
    TABLE_COL_LABELS: ["Code",	"Description",	"Type"],
    TOOLTIP: {
      FIRST_LINE: "Transfer Codes are used as identifiers for transferring live phone calls.",
      SECOND_LINE: "You can transfer a live call to any Talkroute Transfer Code.",
      THIRD_LINE: "To learn more about how to use Transfer Codes,",
      PRINT: "Print",
    }
  },
  TEXT_MESSAGING: {
    TITLE: "Text Messaging",
    CURRENT_USAGE: "Current Usage",
    TABLE_COL_LABELS: ["Virtual Phone Number"],
    AUTO_RESPONDER: "Auto Responder",
    EMAIL_NOTIFICATIONS: "Email Notifications",
    ENABLE: "Enable"
  },
  HOURS_OF_OPERATION: {
    TITLE: "Hours of Operation",
    EMPTY_RESPONSE_MESSAGE: "No operational hours set",
    ERROR_ON_FETCHING: "Encountered an issue when fetching your data. Try again in a few minutes",
    ADD_BUTTON_LABEL: "Add Time Slot",
    TABLE_COL_LABELS: ["Days",	"Start Time",	"End Time",	"Settings",	"Delete"],
    CREATE_DIALOG: {
      TITLE: "Add a Time Slot",
      PRESETS_FIELD_LABEL: "Day Presets",
      START_DAY_LABEL: "Start Day",
      END_DAY_LABEL: "End Day",
      START_TIME_LABEL: "Start Time",
      END_TIME_LABEL: "End Time"
    },
    SETTINGS_DIALOG: {
      TITLE: "Hours of Operation Settings",
      AFTER_HOURS_FILE_FIELD_LABEL: "After Hours Audio File",
      AFTER_HOURS_FILE_FIELD_SUBTEXT: "What callers will hear",
      AFTER_HOURS_DESTINATION_FIELD_LABEL: "After Hours Destination",
      AFTER_HOURS_DESTINATION_SUBTEXT: "Where callers will be redirected to",
      TIMEZONE_FIELD_LABEL: "Timezone"
    },
    EDIT_DIALOG: {
      TITLE: "Time Slot Settings",
    },
    DELETE_DIALOG: {
      TITLE: "Delete Time Slot",
      BODY: "Are you sure you want to delete this time slot?"
    }
  },
  AUDIO_FILES: {
    TITLE: "Greetings & Music on Hold",
    ADD_FILE_LABEL: "Add Audio File",
    DISPLAY_DEFAULTS_LABEL: "Display Defaults",
    NAME_REQUIRED_ERROR: "Description is required",
    NAME_CHAR_LIMIT_ERROR: "The Description may not be longer than 50 characters",
    TABLE_COL_LABELS: ["Description",	"Start Time",	"Play",	"Settings",	"Delete"],
    ADD_FILE_DIALOG: {
      TITLE: "Add an Audio File",
      FORM_STEP_ONE: "Record or Upload Audio",
      FORM_STEP_TWO: "Description & Type",
      FILE_TYPE_FIELD_LABEL: "File Type",
      DESCRIPTION_FIELD_LABEL: "Description",
    },
    EDIT_DIALOG: {
      TITLE: "Edit Audio File",
    },
    DELETE_DIALOG: {
      TITLE: "Delete Audio File",
      BODY: "Are you sure you want to permanently remove this audio file?",
      FILE_USED_MSG: "This resource is currently in use in the Talkroute system",
    }
  },
  VOICE_MAILBOX: {
    TITLE: "Voicemail",
    ADD_MAILBOX_BTN_LABEL: "Add Voice Mailbox",
    DESCRIPTION_TOO_LONG_ERROR: "The description may not be longer than 255 characters",
    INVALID_EMAIL_ERROR: "Please enter a valid email address",
    EMAIL_REQUIRED_ERROR: "Required field!",
    DESCRIPTION_REQUIRED_ERROR: "Description is required",
    VOICEMAIL_IS_USED_TOOLTIP: "This file is currently in use in the Talkroute system",
    TABLE_COL_LABELS: ["Description",	"Email",	"Voicemail Greeting",	"Play", "Settings",	"Delete"],
    CREATE_DIALOG: {
      TITLE: "Add a Voice Mailbox",
      GREETING_FIELD_LABEL: "Select Greeting",
      INPUT_DISPLAY_TRANSCRIPTS_LABEL: "Show Voice Message Transcripts",
      INPUT_SHOW_TRANSCRIPTS_LABEL: "Show Transcripts in Email",
      INPUT_ATTACH_AUDIO_LABEL: "Attach Audio File to Email",
      EMAIL_FIELD_LABEL: "Voicemail to E-Mail",
    },
    EDIT_DIALOG: {
      TITLE: "Mailbox Setting",
    },
    DELETE_DIALOG: {
      TITLE: "Delete Voice Mailbox",
      BODY: "Are you sure you want to permanently remove this Voice Mailbox?",
      DELETE_CONFIRMATION_TEXT: "delete",
      VOICEMAIL_IS_USED: "This Voice Mailbox is used to handle calls during after hours",
    }
  },
  BLOCKED_PHONE_NUMBERS: {
    TITLE: "Blocked Numbers",
    BLOCK_ANONYMOUS_CALLERS: "Block anonymous callers",
    BLOCK_NUMBER: "Add Blocked Number",
    BLOCK_DIALOG: "Add New Blocked Phone Number",
    INVALID_NUMBER: "Invalid phone number",
    TABLE_COL_LABELS: ["Phone Number",	"Unblock"],
  },
  ERROR_MESSAGES: {
    INVALID_NUMBER: "Invalid phone number",

  },
  PAYWALL_DIALOG: {
    HEADER:"Not Supported",
    HEADER_DISCOVERED_PREMIUM_FEATURE: "You've Discovered a Premium Feature",
    HEADER_MAILBOX_LIMIT: "You've Exceeded Your Mailbox Limit",
    REPORTING_TEXT: "Unfortunately, advanced filters and reporting are not supported by your current subscription plan. Please visit our Billing page to compare plans and upgrade your account.",
    CALL_MENU_TEXT: "Call menu management is not supported by your current subscription plan. Visit the Billing page to compare plans and upgrade your account.",
    CALLER_ID_ROUTING_TEXT: "Blocking anonymous callers is not supported by your current subscription plan. Visit the Billing page to compare plans and upgrade your account.",
    USER_EXTENSION_TEXT: "User extensions are not supported by your current subscription plan. Visit the Billing page to compare plans and upgrade your account.",
    HOURS_OF_OPERATIONS_TEXT: "Unfortunately, hours of operation are not supported by your current subscription plan. Please visit our Billing page to compare plans and upgrade your account.",
    TRANSFER_CODES_TEXT: "Unfortunately, transfer codes are not supported by your current subscription plan. Please visit our Billing page to compare plans and upgrade your account.",
    VMBOX_TEXT: "The mailbox that you are trying to add exceeds the number of mailboxes included with your current subscription plan. Please visit our Billing page to compare plans and add-ons available for your account.",
    DEFAULT_TEXT: "This feature is not supported by your current subscription plan. Visit the Billing page to compare plans and upgrade your account.",
    REDIRECT_LABEL: "Go to Billing",
    PRICING_PAGE: "https://cp.talkroute.com/account#!/accountInformation",
  },
}

const textConversations = {
  QUICK_REPLY_FAILED_DIALOG: {
    HEADER: "Quick reply failed.",
    BODY: "The conversation either does not exist or you do not have permission to view it.",
    CONFIRM_BUTTON_LABEL: "Close",
  }
}
/**
 * Constants for various pieces of text displayed to the user.
 * This will make it easier when we implement localization
 */
 const uiString = {
  ALL_CALLS: "All Calls",
  ALL_MAILBOXES: "All Mailboxes",
  ALL_MESSAGES: "All Messages",
  EMPTY_CALL_HISTORY: "Your Call History is empty",
  EMPTY_CONVERSATIONS: "No Text Messages",
  EMPTY_VOICEMAILS: "No Voicemail Messages",
  ERROR_LOADING_DATA_GENERIC: "Error loading data",
  WORKING_OFFLINE: "Working offline",
  RELOAD: "Reload",
  HOST: "Host",
  CALLBACK: "Call Back",
  MARK_AS_READ: "Mark As Read",
  CALL_DETAILS: "Call Details",
  VOICEMAIL_DETAILS: "Voicemail Details",
  CONVERSATION_DETAILS: "Message Details",
  LOADING_CALL_HISTORY: "Loading Call History...",
  VIRTUAL_PHONE_NUMBER: "Virtual Phone Number",
  CALLER_NUMBER: "Caller Phone Number",
  FILTER_BY: "Filter by",
  DATE_AND_TIME: "Date & Time",
  DIRECTION: "Direction",
  DURATION: "Duration",
  SETTINGS: "Settings",
  RELATED_CALLS: "Recent Calls",
  NO_DETAILS_AVAILABLE: "No details available",
  NEXT: "Next",
  SECONDS: "Seconds",
  MINUTES: "Minutes",
  STATUS: "Status",
  PHOTO_ATTACHMENT: "Photo Attachment",
  RECORD: "Record",
  STOP: "Stop",
  UPLOAD: "Upload",
  ABORT: "Abort",
  DONE: "Done",
  CANCEL: "Cancel",
  SAVE_CHANGES: "Save Changes",
  PREVIEW: "Preview",
  LOGOUT: "Logout",
  ERROR: "Error",
  DELETE: "Delete",
  SUBMIT: "Submit",
  UPDATE: "Update",
  START: "Start",
  LINK: "Link",
  CREATE: "Create",
  FUTURE: "Future",
  SUBHEADER: "Subheader",
  RESET: "Reset",
  BACK: "Back",
  CONTACTS: {
    PAGE_HEADER: "Contacts",
    ADD_PHONE_DIALOG_HEADER: "Add Phone Number",
    ADD_PHONE_INPUT_BUTTON_LABEL: "Add Number",
    VIEW_CONTACTS: {
      DIALOG_HEADER: "Redirect Confirmation",
      DIALOG_BODY: "Are you sure you want to be redirected to Keypad?",
      DIALOG_TEXT_CONTACT_BODY: "Are you sure you want to be redirected to Text Messages?",
      DIALOG_CONFIRM_BUTTON: "Confirm"
    }
  },
  BLOCK: "Block",
  callStatus: {
    ANSWERED: "Answered",
    MISSED: "Missed",
    HANGUP: "Hang up",
    CLOSED: "Closed",
    BLOCKED: "Blocked",
    OUTGOING: "Outgoing",
    NOTAVAILABLE: "Not Available",
    ONLINE: "Online",
  },
  callType: {
    INBOUND: "Inbound",
    OUTBOUND: "Outbound",
    NOTAVAILABLE: "Not Available",
  },
  preferences: {
    CALL_HISTORY_AND_REPORTING: "Call History & Reporting",
    TRANSFER_CODES: "Transfer Codes",
    CALL_ROUTING: "Call Routing",
    PHONE_SYSTEM: "Phone System",
    HISTORY_AND_REPORTING: "Record Type",
    COMPANY: "Company",
    YOUR_PROFILE: "Your Profile",
    TURN_ON_AUTO_UPDATE: "Enable Automatic Updates",
    TURN_ON_SPELL_CHECK: "Enable spellcheck for messages",
    UPDATE_NOW: "Update Now",
    UPDATES: "Updates",
    LAST_UPDATE_CHECK: "Last Update Check",
    CURRENT_APP_VERSION: "Current App Version",
    NEVER: "Never",
    OUTGOING_CALLER_ID: "Outgoing Calls",
    OUTGOING_TEXT_MESSAGE_PHONE_NUMBER: "Outgoing Texts",
    DEFAULT_CALLER_ID: "Default Caller ID",
    USER_CONTROLS: "User Controls",
    CONTROLS: "Controls",
    NOTIFICATIONS: "Notifications",
    INCOMING_CALL_SOUND: "Incoming Call Sound",
    INCOMING_TEXT_SOUND: "Incoming Text Sound",
    INPUT: "Input",
    TEST_INPUT: "Test Input",
    OUTPUT: "Output",
    TEST_OUTPUT: "Test Output",
    CHECK_FOR_UPDATE: "Check for Update",
    CLEAR_DATA: "Clear Application Data",
    CLEAR_DATA_BUTTON: "Clear Data",
    OUTGOING_NONE: "None",
    "SAFARI_OR_FIREFOX_AUDIO_DEVICE_INFORMATION": "On Safari and Firefox you can only change your device through your operating system settings",
    VERSION: 'Version:',
  },
  daysOfWeek: {
    SAME_DAY: "Today",
    NEXT_DAY: "Tomorrow",
    LAST_DAY: "Yesterday",
  },
  MAIN_WINDOW_TITLE: "Talkroute",
  PREFERENCES_WINDOW_TITLE: "Settings & Preferences",
  HISTORY_AND_REPORTING_WINDOW_TITLE: "History & Reporting",
  SELECT_PHONE_NUMBER: "Select Phone Number",
  RETRY: "Retry",
  INPUT_DEVICE: "Device",
  OUTPUT_DEVICE: "Device",
  NOTIFICATION_SOUND: "Notification Sound",
  NO_SOUND: "No Sound",
  TEXT_NOTIFICATION_SOUND_FILES: [
    "Notification01.m4a",
    "Notification02.m4a",
    "Notification03.m4a",
    "Notification04.m4a",
    "Notification05.m4a",
    "Notification06.m4a",
  ],
  TEXT_NOTIFICATION_SOUND_FILE_NAMES: [
    "Chime",
    "Presto",
    "Future",
    "Twinkle",
    "Ripples",
    "Plop",
  ],
  CALL_NOTIFICATION_SOUND_FILES: [
    "Ringing01.m4a",
    "Ringing02.m4a",
    "Ringing03.m4a",
    "Ringing04.m4a",
  ],
  CALL_NOTIFICATION_SOUND_FILE_NAMES: [
    "Digital",
    "Signal",
    "The Office",
    "Old School",
  ],
  READ: "Read",
  UNREAD: "Unread",
  MAILBOX: "Mailbox",
  MESSAGE_FROM: "Message From",
  FROM: "From",
  SHOW_DETAILS: "Show Details",
  CALL: "Call",
  CALLING: "Calling",
  CALL_FROM: "Call from",
  SET_DEFAULT_IN_PREFERENCES: "Set default in Preferences",
  ACCEPT: "Accept",
  DELETE_CONTACT_CONFIRMATION_HEADER: "Delete Confirmation",
  DELETE_CONTACT_CONFIRMATION_BODY: "Are you sure you want to delete this Contact data?",
  VOICEMAIL_DELETE_CONFIRMATION_HEADER: "Delete Voicemail from",
  DELETE_TIMESLOT_CONFIRMATION_HEADER: "Delete Time Slot",
  DELETE_TIMESLOT_CONFIRMATION_BODY: "Are you sure you want to delete this time slot?",
  DELETE_FPN_CONFIRMATION_HEADER: "Delete Forwarding Phone Number",
  DELETE_FPN_CONFIRMATION_BODY: "Are you sure you want to permanently remove this number",
  DELETE_MAILBOX_CONFIRMATION_HEADER: "Delete Voice Mailbox",
  DELETE_MAILBOX_CONFIRMATION_BODY: "Are you sure you want to permanently remove this voice mailbox?",
  DELETE_AUDIO_FILE_CONFIRMATION_HEADER: "Delete Audio File",
  DELETE_AUDIO_FILE_CONFIRMATION_BODY: "Are you sure you want to permanently remove this audio file?",
  VOICEMAIL_DELETE_CONFIRMATION_BODY:
    "Are you sure you want to delete this Voicemail?",
  CONVERSATION_DELETE_CONFIRMATION_HEADER: "Delete Confirmation",
  CONVERSATION_DELETE_CONFIRMATION_BODY:
    "Are you sure you want to delete this Conversation?",
  MULTIPLE_CONVERSATIONS_DELETE_CONFIRMATION_BODY:
    "Are you sure you want to delete the selected conversations?",
  VOICEMESSAGE_DELETE_CONFIRMATION_HEADER: "Delete Confirmation",
  MULTIPLE_VOICEMESSAGE_DELETE_CONFIRMATION_BODY: "Are you sure you want to delete the selected voice messages?",
  VOICEMESSAGE_DELETE_CONFIRMATION_BODY: "Are you sure you want to delete this voice message?",
  aboutStrings: {
    ABOUT: "About",
    ABOUT_TALKROUTE: "About Talkroute",
  },
  updateStrings: {
    CANCEL: "Cancel",
    INSTALL: "Install",
    NEW_UPDATE_AVAILABLE_TITLE: "New Version Available",
    NEW_UPDATE_AVAILABLE_MESSAGE:
      "A new Version of the Talkroute Desktop App is available.",
    NEW_UPDATE_AVAILABLE_DETAIL: "Quit and install update?",
    AUTO_UPDATE_ERROR_TITLE: "Error downloading update",
    AUTO_UPDATE_ERROR_MESSAGE:
      "There was an error downloading update. Please try again later.",
  },
  OK: "OK",
  conversationDetails: {
    TO: "To",
    VIRTUAL_PHONE_NUMBER: "Virtual Phone Number",
    MESSAGE_COUNT: "Total Messages",
    LAST_MESSAGE_DETAILS: "Last Message",
    MESSAGE: "Message",
    SENT_AT: "Sent At",
    SENT_BY: "Sent By",
    N_A: "N/A",
  },
  NEW_CONVERSATION: "New Conversation",
  END_OF_CONVERSATIONS: "End of conversations",
  LOADING: "Loading",
  PULL_TO_REFRESH: "Pull down to refresh",
  RELEASE_TO_REFRESH: "Release to refresh",
  INVALID_NUMBER: "Invalid Phone Number",
  MESSAGE_NOT_AVAILABLE: "The message you requested is no longer available",
  NOT_A_VALID_PHONE_NUMBER: "is not a valid phone number",
  EMPTY_PHONE_NUMBER: "Please enter a phone number to call.",
  NEW_MESSAGE: "New Message",
  BY: "By",
  SEND: "Send",
  ENTER_TO_SEND: "Enter to send",
  SHIFT_ENTER_INSERT_NEW_LINE: "Shift + Enter to insert a new line",
  ENTER_PHONE_NUMBER: "Enter a phone number",
  COPYRIGHT: "Copyright (c) 2023 Talkroute",
  authentication: {
    EMAIL_ADDRESS: "Email",
    PASSWORD: "Password",
    IS_REQUIRED: "is required",
    LOGIN: "LOG IN",
    NEW_TO_US: "New to us?",
    SIGN_UP: "Sign Up",
    CREATE_ACCOUNT: "Create Account",
    FORGET_PASSWORD: "Forget Password?",
  },
  ERROR_CONNECTING_TO_NOTIFICATION: "Notifications are currently unavailable.",
  CONNECTED_TO_NOTIFICATION: "Notifications are now available.",
  ERROR_CONNECTING_TO_SIP: "Trying to connect to our servers...",
  CONNECTED_TO_SIP: "Talkroute is now connected.",
  RECONNECTING_TO_SIP: (attempt: number) =>
    `Talkroute is trying to reconnect...`,
  GROUP_TEXT_NOTIFICATION_BODY_HEAD: "You have ",
  GROUP_TEXT_NOTIFICATION_BODY_TAIL: " new messages",
  GROUP_TEXT_NOTIFICATION_TITLE: "Text message",
  GROUP_VOICEMAIL_NOTIFICATION_BODY_HEAD: "You have ",
  GROUP_VOICEMAIL_NOTIFICATION_BODY_TAIL: " new voicemails",
  GROUP_VOICEMAIL_NOTIFICATION_TITLE: "Voicemail",
  AUTH_ERROR:
    "There was a problem logging in. Please try again or contact Talkroute Support.",
  VOICEMAIL_FILE_NOT_FOUND_ERROR:
    "The Voicemail could not be retrieved, it may have been deleted already.",
  UNSUPPORTED_ATTACHMENT_TYPE:
    "The selected File is an unsupported type for sending as an attachment.",
  FILE_TOO_LARGE:
    "The selected File is too large to be sent as an attachment​.",
  SAVE_AS: "Save As",
  OPEN_IMAGE: "Open Image",
  MAX_NUMBER_LOGINS_REACHED:
    "You have reached your maximum number of logins for the Talkroute Desktop App. Please log out of an existing installation before continuing.",
  CALL_ENDING: "Call ending",
  CALL_CONNECTING: "Call connecting",
  NO_DEVICE_AVAILABLE: "No input/output device available",
  calls: {
    UNKNOWN: "Unknown",
    FROM: "From",
    TO: "To",
    CALLING: "Calling",
    INCOMING: "Incoming",
    DIALED: "Dialed",
  },
  PRICING_PAGE: "https://talkroute.com/pricing",
  COMPANY_PAGE_BILLING_LINK: "https://cp.talkroute.com/settings#!/forwarding",
  COMPANY_PAGE_LINK: "https://cp.talkroute.com",
  SUPPORT_PAGE_LINK: "https://support.talkroute.com",
  SIGN_UP_LINK: "https://talkroute.com/sign-up/",
  FORGOT_PWD_LINK: "https://cp.talkroute.com/resetting/request",
  DESKTOP_DOWNLOAD_LINK: "https://www.talkroute.com/downloads",
  PAYWALL: {
    HEADER:"Not Supported",
    // CONTENT:"You need to upgrade your subscription plan to Plus or above in order to access this feature. Visit the Plans & Pricing page for more details.",
    CONTENT: "Advanced filters are not supported by your subscription plan. Visit the Plans & Pricing page for more details.",
    REDIRECT_LABEL: "Go to Plans & Pricing"
  },
  initialModal: {
    NEXT: "Next",
    BACK: "Back",
    FINISH: "Finish",
    welcomeModal: {
      TITLE: "Welcome to Talkroute",
      SUMMARY:
        "Thank you for choosing our Desktop App to manage your business calls and messages!",
      CONTENT: "A few things you will be able to do with our app:",
      FUNC_1: "- Make & receive business calls",
      FUNC_2: "- Review your call history",
      FUNC_3: "- Send & receive text messages",
      FUNC_4: "- Receive & listen voicemails",
      DESC:
        "Please feel free to send any feedback or suggestions regarding your experience with our Desktop App to appfeedback@talkroute.com",
    },
    callerModal: {
      TITLE: "Caller ID",
      SUMMARY:
        "Select the phone number to display on the Outgoing Caller ID for calls and texts:",
      DESC:
        "Default Caller ID settings may be changed at anytime in your Settings & Preferences.",
    },
    termsModal: {
      TITLE: "Terms & Conditions",
      SUMMARY: "911 & E911 Not Supported",
      DESC_1: "The Talkroute apps ",
      DESC_BOLD: "DO NOT",
      DESC_2:
        " support 911 access to emergency services. Talkroute advises customer to maintain or acquire an alternative means of accessing 911 services. Customer agrees to advise all employees, visitors, and other persons who may be present at the physical location where the customer utilizes the service that Talkroute does not support 911 service and provide an alternative means of 911 dialing.",
      CHECK_DESC:
        "I understand the Talkroute apps do not support 911 or E911 dialing and agree to the Terms & Conditions.",
      I_AGREE: "I Agree to the "
    },
  },
  confirmModal: {
    CANCEL: "Cancel",
    HANGUP: "End Call",
    endCall: {
      TITLE: "End Current Call",
      DESC: "Confirm that you wish to disconnect the active call with",
    },
    declineCall: {
      TITLE: "Decline Current Call",
      DESC: "Confirm that you wish to decline the incoming call with",
    },
  },
  blockPermissionErrorModal: {
    TITLE: "Block/Unblock Call",
    DESC:
      "Your account does not have the permissions to block/unblock calls. Please contact your system administrator for further information",
  },
  unBlockNumberModal: {
    DESC: "Are you sure you want to unblock this number?",
    CONFIRM: "Confirm"
  },
  noDeviceAvailableModal: {
    TITLE: "No input device available",
    DESC:
      "Please go to Settings & Preferences and select an input device.",
  },
  noDeviceAvailableToast: "Unable to detect a microphone",
  welcomeTextMessage: {
    FROM: "Talkroute",
    LAST_MESSAGE_TEXT: "Welcome to Text Messaging",
    MESSAGE_1_BODY:
      "Your Talkroute phone number can be configured to send and receive text messages.",
    MESSAGE_2_BODY:
      "To activate text messaging for your number, please visit our text messaging tutorial that can be found in",
    MESSAGE_3_BODY:
      "Getting Started: How to Send Text Messages https://support.talkroute.com/hc/en-us/articles/115005857707-Getting-Started-How-to-Send-Text-Messages Replying is disabled in this message, you can delete this message when you are done with it.",
  },
  // voicemailPreferences: {
  //   UPDATE_DIALOG_HEADER: "Mailbox Setting",
  //   ADD_DIALOG_HEADER: "Add a Voice Mailbox",
  //   ADD_BUTTON_TEXT: "Add Voice Mailbox",
  //   CALL_ANNOUNCE_AND_TALKROUTE_VOICEMAIL: "Voicemail & Call Announce Enabled",
  // },
  welcomeVoicemail: {
    FROM: "Talkroute",
    MAILBOX: "Welcome to Talkroute",
    FILE_PATH: "TalkrouteWelcomeVMPhoneQuality.wav",
    DURATION: 29,
  },
  blockedNotifications: {
    BLOCKED: "This number is now blocked.",
    UNBLOCKED: "This number is now unblocked.",
  },
  tooltips: {
    SETTINGS_BUTTON: "Settings",
    HISTORY_AND_REPORTING_BUTTON: "History & Reporting",
    CONTROL_PANEL_BUTTON: "Control Panel",
    SUPPORT_BUTTON: "Support",
    DOWNLOAD_BUTTON: "Download",
    PRINT_BUTTON: "Print",
  },
  footerBanner: {
    MAIN_TEXT: "Be sure to install our apps for desktop and mobile devices - ",
    LINK_TEXT: "Click Here to Download",
  },
  callHistoryView: {
    DELETE_CALL_CONFIRMATION_HEADER: "Delete Call Recording",
    DELETE_CALL_CONFIRMATION_BODY: "Are you sure you want to permanently remove this call recording?",
    table: {
      DATE_TIME: "Date & Time",
      PHONE_NUMBER: "Phone number",
      DURATION_TABLE: "Duration",
      RECORDING: "Recording",
    },

  },
  hoursOfOperations: {
    HOURS_OF_OPERATION: "Hours of Operation",
    // EMPTY_RESPONSE_MESSAGE: "No operational hours set",
    // ERROR_ON_FETCHING: "Encountered an issue when fetching your data. Try again in a few minutes",
    DESCRIPTION: "Description",
    NUMBER: "Number",
    ENABLE_CALL_ANNOUNCE: "Enable Call Announce & Talkroute Voicemail",
    EDIT_NUMBER: "Edit Number",
    ADD_FORWARDING_PHONE_NUMBER: "Add a Forwarding Phone Number",
    DAY_PRESETS: "Day Presets",
    EVERY_DAY: "Every day",
    COMMON_RANGES: "Common Ranges",
    MONDAY_TO_FRIDAY: "Monday to Friday",
    MONDAY_TO_THURSDAY: "Monday to Thursday",
    SATURDAY_TO_SUNDAY: "Saturday and Sunday",
    INDIVIDUAL_DAYS: "Individual days",
    START_DAY: "Start Day",
    END_DAY: "End Day",
    START_TIME: "Start Time",
    END_TIME: "End Time",
    ADD_TIME_SLOT: "Add a Time Slot",
    TIME_SLOT_SETTINGS: "Time Slot Settings"
  },
  form: {
    FIELD_REQUIRED: "This field is required",
    INVALID_PHONE_NUMBER: 'Invalid phone number',
  },
  contextMenu: {
    SELECT_ALL_ENTRIES: "Select All Entries",
    DESELECT_ALL_ENTRIES: "Deselect All Entries",
    MARK_ALL_AS_READ: "Mark All As Read",
    DELETE: "Delete",
    SELECT_AND_DELETE_ALL: "Select & Delete All",
  },
  transferCodes: {
    TOOLTIP: {
      FIRST_LINE: "Transfer Codes are used as identifiers for transferring live phone calls.",
      SECOND_LINE: "You can transfer a live call to any Talkroute Transfer Code.",
      THIRD_LINE: "To learn more about how to use Transfer Codes,"
    }
  },
  SETTINGS_AND_PREF: preferences,
  TEXT_CONVERSATIONS: textConversations,
  IMPERSONATION: {
    NOTIFY: "You are currently impersonating user: ",
    EXIT: "Exit"
  }
};

export const ApiErrorMessages = {
  UNEXPECTED: "An unexpected error has occurred. Please try again later",
  UNAUTHORIZED: "You are not authorized to perform this action",
  FORBIDDEN: "This action is forbidden"
}
export const siteLinks = {
  TRANSFER_CODES_ARTICLE: "https://support.talkroute.com/hc/en-us/articles/215492508-How-to-Transfer-Live-Calls",
  NO_CALL_DETAILS_FAQ: "https://support.talkroute.com/hc/en-us/articles/360000214267",
}
export enum ErrorWrapperMessages {
  FETCH_DATA_ERROR = "Encountered an issue when fetching data. Try again in a few minutes",
  NOT_AUTHORIZED_TO_VIEW = "You are not authorized to view this page"
}

export default uiString;
